import { render, staticRenderFns } from "./teacherLeaveForm.vue?vue&type=template&id=3ccbfdfe&scoped=true&"
import script from "./teacherLeaveForm.vue?vue&type=script&lang=js&"
export * from "./teacherLeaveForm.vue?vue&type=script&lang=js&"
import style0 from "./teacherLeaveForm.vue?vue&type=style&index=0&id=3ccbfdfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccbfdfe",
  null
  
)

export default component.exports